<template>
	<MStateBox :loading="isLoading" :empty="isEmpty">
		<div class="wrapper-box">
			<RowInfoLink
				v-for="(item, index) in currentData"
				:key="index"
				:sort="index + 1"
				:item="item"
				:border="true"
				@click="goDetail(item)"
			>
				<div slot="more" class="box-more">
					<span>{{ $t('enterprise.view-details') }}</span>
					<i class="iconfont icon-flip-right"></i>
				</div>
			</RowInfoLink>
		</div>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import { useCurrentContext } from '@rebuild/materials/shared/announcement/context';
import RowInfoLink from '@/views/home/components/RowInfoLink.vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import dayjs from 'dayjs';

const route = useRoute();
const { announcement } = useModuleData();
const { viewModule } = useModuleNavigation();

const context = useCurrentContext();
const languageType = computed(() => context.languageType);

const goDetail = item => {
	viewModule('announcement', item);
};

const currentData = computed(() => {
	const all = (announcement.data?.rows || []).slice(0, 8).map(item => ({
		...item,
		time: dayjs(item.publishDate).valueOf()
	}));
	const slice = route.query.slice;
	if (slice === 'left4') return all.slice(0, 4);
	if (slice === 'right4') return all.slice(4, 8);
	return all;
});

const isLoading = computed(() => announcement.loading);
const isEmpty = computed(() => announcement.empty || !currentData.value.length);

const loadData = async () => {
	await announcement.refresh({
		useStockCode: true,
		pageNum: 20,
		pageStart: 0,
		order: 'desc',
		isPublish: true,
		...languageType.value
	});
};

onMounted(() => {
	loadData();
});
</script>

<style lang="less" scoped>
.wrapper-box {
	:deep(.link-row) {
		padding-top: 12px;
		padding-bottom: 12px;

		& + .link-row {
			margin-top: 0;
		}
	}
	:deep(.link-sort) {
		top: 12px;
	}

	.box-more {
		display: flex;
		align-items: center;
		cursor: pointer;

		span {
			color: #86909c;
			text-align: right;
			font-size: 14px;
			font-weight: 400;
			line-height: 16px;
		}
		.iconfont {
			font-size: 16px;
			color: #86909c;
		}
	}
}
</style>
